// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_l7-1";
export var rowFirst = "_l7-3";
export var rowLast = "_l7-5";
export var rowMiddle = "_l7-4";
export var ticketListScroll = "_l7-2";
export var ticketStack = "_l7-0";